import { render, staticRenderFns } from "./SocialHistory.vue?vue&type=template&id=5cccd975&"
import script from "./SocialHistory.vue?vue&type=script&lang=ts&"
export * from "./SocialHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cccd975')) {
      api.createRecord('5cccd975', component.options)
    } else {
      api.reload('5cccd975', component.options)
    }
    module.hot.accept("./SocialHistory.vue?vue&type=template&id=5cccd975&", function () {
      api.rerender('5cccd975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/SocialHistory.vue"
export default component.exports